"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var LinkCopier_1 = __importDefault(require("atomicComponents/organisms/LinkCopier"));
var constants_1 = require("utils/constants");
var single_1 = require("utils/selectors/single");
var ForwardingAddress = function (_a) {
    var setStep = _a.setStep;
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var forwardingAddress = constants_1.FB_ENV_FE === 'prod'
        ? "imports+".concat(rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargeMiniId, "@rechargly.com")
        : "recharges.staging+".concat(rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargeMiniId, "@hudled.com");
    return ((0, jsx_runtime_1.jsx)(LinkCopier_1.default, { text: forwardingAddress, onCopy: setStep }));
};
exports.default = ForwardingAddress;
